const NEXT_STEP = "NEXT_STEP";
const BACK_STEP = "BACK_STEP";
const RESET_STEP = "RESET_STEP";
const ADD_RESUME = "ADD_RESUME";
const REMOVE_RESUME = "REMOVE_RESUME";
const REMOVE_ALL_RESUMES = "REMOVE_ALL_RESUMES";

export {
  NEXT_STEP,
  BACK_STEP,
  RESET_STEP,
  ADD_RESUME,
  REMOVE_RESUME,
  REMOVE_ALL_RESUMES,
};
